// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-chart1 {
  width: 100%;
  height: 100%;
}

.cont-home {
  display: grid;
  width: 95%;
  margin: auto;
  margin-bottom: 10%;
}

.dash {
  margin-top: 2%;
  box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.28);
  -webkit-box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.28);
  -moz-box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.28);
  height: 100%;
}


.cont-nav {
  padding: 5px 20px 5px 20px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #e6e9ed;
}

.cont-nav a {
  color: #73879c;
  font-weight: 700;
}

.nav-item {
  list-style-type: none;
}

.img-dash {
  width: 80px;
  height: 80px;
}

.select-Temp {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1%;
}

.select-Temp p {
  font-size: 14px;
  text-align: center;
}

.cont-dashselector {
  overflow-y: auto;
}

.btn-reload {
  border: none;
  background-color: transparent;
  font-size: 1rem;
  color: #759eb8;
  margin: 0%;
  padding: 0%;
}

.btn-reload:hover {
  background-color: transparent;
}

.div1Contents {
  display: none;
}

/* Responsive*/
@media (max-width: 851px) {

  .parent {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .div1 {
    display: none;
    margin-bottom: 10px;
  }

  .div1 {
    display: flex;
    margin-bottom: 10px;
  }

  .div1Contents {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px;
  }

  .btn-reload.mobile {
    display: inline-flex;
    align-items: center;
    font-size: 1.1rem;
    padding: 5px;
  }
  

  .cont-home {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
  }

  .dash {
    max-width: 100%;
    margin-right: 0;
    margin-top: 10px;
    padding: 10px;
    box-sizing: border-box;
  }

  .cont-dashselector {
    width: 100%;
    overflow-x: auto;
    padding: 10px 0;
  }

  .cont-nav {
    flex-direction: column;
    align-items: flex-start;
    padding: 10px;
  }

  .nav-item {
    width: 100%;
    margin: 5px 0;
  }

  .img-dash {
    max-width: 10vw;
    max-height: 10vw;
  }

  .select-Temp p {
    font-size: 12px;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,uDAAuD;EACvD,oDAAoD;EACpD,YAAY;AACd;;;AAGA;EACE,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;AACb;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA,cAAc;AACd;;EAEE;IACE,aAAa;IACb,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;EACd;;;EAGA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":[".cont-chart1 {\n  width: 100%;\n  height: 100%;\n}\n\n.cont-home {\n  display: grid;\n  width: 95%;\n  margin: auto;\n  margin-bottom: 10%;\n}\n\n.dash {\n  margin-top: 2%;\n  box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.28);\n  -webkit-box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.28);\n  -moz-box-shadow: 1px 1px 8px 2px rgba(0, 0, 0, 0.28);\n  height: 100%;\n}\n\n\n.cont-nav {\n  padding: 5px 20px 5px 20px;\n  display: flex;\n  justify-content: space-between;\n  border-bottom: 2px solid #e6e9ed;\n}\n\n.cont-nav a {\n  color: #73879c;\n  font-weight: 700;\n}\n\n.nav-item {\n  list-style-type: none;\n}\n\n.img-dash {\n  width: 80px;\n  height: 80px;\n}\n\n.select-Temp {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 1%;\n}\n\n.select-Temp p {\n  font-size: 14px;\n  text-align: center;\n}\n\n.cont-dashselector {\n  overflow-y: auto;\n}\n\n.btn-reload {\n  border: none;\n  background-color: transparent;\n  font-size: 1rem;\n  color: #759eb8;\n  margin: 0%;\n  padding: 0%;\n}\n\n.btn-reload:hover {\n  background-color: transparent;\n}\n\n.div1Contents {\n  display: none;\n}\n\n/* Responsive*/\n@media (max-width: 851px) {\n\n  .parent {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n  }\n\n  .div1 {\n    display: none;\n    margin-bottom: 10px;\n  }\n\n  .div1 {\n    display: flex;\n    margin-bottom: 10px;\n  }\n\n  .div1Contents {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 10px;\n  }\n\n  .btn-reload.mobile {\n    display: inline-flex;\n    align-items: center;\n    font-size: 1.1rem;\n    padding: 5px;\n  }\n  \n\n  .cont-home {\n    width: 100%;\n    padding: 10px;\n    box-sizing: border-box;\n  }\n\n  .dash {\n    max-width: 100%;\n    margin-right: 0;\n    margin-top: 10px;\n    padding: 10px;\n    box-sizing: border-box;\n  }\n\n  .cont-dashselector {\n    width: 100%;\n    overflow-x: auto;\n    padding: 10px 0;\n  }\n\n  .cont-nav {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 10px;\n  }\n\n  .nav-item {\n    width: 100%;\n    margin: 5px 0;\n  }\n\n  .img-dash {\n    max-width: 10vw;\n    max-height: 10vw;\n  }\n\n  .select-Temp p {\n    font-size: 12px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
